import React, { useState } from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import cn from 'classnames';
import DealerAdIframe from '../../dealer';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import adunitStyles from './adunits.scss';
const AdhesionGak = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const [hidden, setHidden] = useState(false);
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    const { advertIsOff  } = useAdUnit(AdProviders.Freestar, ADUNIT_MAP['AdhesionGam'], safety, {
        targeting: {
            unitType: 'atf'
        }
    });
    if (advertIsOff) {
        if (!isNsfgFallback) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: cn(adunitStyles['adhesion'], hidden && adunitStyles['hidden'])
        }, !hidden && /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '728px',
                height: '90px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['DesktopAdhesionGam'],
            neverCollapse: true,
            fillBlock: true
        })), /*#__PURE__*/ React.createElement(IconButton, {
            "aria-label": "Hide Advertisment",
            icon: Close,
            size: 'small',
            onClick: ()=>{
                setHidden(true);
            }
        }));
    }
    // Unit has no chrome
    return null;
}, adunitMemo);
AdhesionGak.displayName = 'AdhesionGak';
export default AdhesionGak;
